import * as types from './actionTypes';
import {api} from '../utility';
import store from 'store';
import _ from 'lodash';

export function loginUserSuccess(token) {
    return { type: types.LOGIN_USER_SUCCESS, token};
}

export function logoutUserSuccess() {
  return { type: types.LOGOUT_USER_SUCCESS};
}

export function loginAdthriveUserSuccess(token, name, email) {
    return { type: types.LOGIN_ADTHRIVE_USER_SUCCESS, token, name, email};
}

export function setAdthriveSites(sites) {
    return { type: types.SET_ADTHRIVE_SITES, sites};
}

export function setActiveSite(site) {
    return { type: types.SET_ACTIVE_SITE, site};
}

export function loginUser(email,password,openSnackBar,setLoginInProgress, callback){
  return function (dispatch, getState) {
    return fetch(api.GET_BASE_URL('TOPIC_BASE_URL') + api.LOGIN_ENDPOINT + `?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
      method: 'GET'
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      dispatch(loginUserSuccess(data.token));
      if(_.isFunction(callback)){
        callback();
      }
    })
    .catch(function(error) {
      setLoginInProgress(false);
      openSnackBar("Invalid Email/Password");
    });
  };
}

export function logoutUser(){
  return function (dispatch, getState) {
    dispatch(logoutUserSuccess());
  };
}

export function loginAdthriveUser(setLoginInProgress, callback){
  return function (dispatch, getState) {
    let authURL = `${api.GET_BASE_URL('ADTHRIVE_PUBDASH_BASE_URL')}${api.ADTHRIVE_PUBDASH_LOGIN_ENDPOINT}${/\?/.test(api.GET_BASE_URL('ADTHRIVE_PUBDASH_BASE_URL')) ? '&' : '?'}plugin=topic`;
    let params = `width=600,height=700,left=100,top=100`;
    var popup = window.open(authURL, 'AdThrive Login', params);
    window.addEventListener("message", (e) => {
      console.log('RECEIVED MESSAGE', e);
      window.removeEventListener('message');
      let {token, name, email} = e.data;
      dispatch(loginAdthriveUserSuccess(token, name, email));
      setLoginInProgress(false);
      if(_.isFunction(callback)){
        callback();
      }
    });
  };
}

export function loginAdThriveUserManually(token, name, email, callback){
  return function (dispatch, getState) {
    dispatch(loginAdthriveUserSuccess(token, name, email));
    if(_.isFunction(callback)){
      callback();
    }
  };
}

export function fetchAdthriveSites(callback){
  let adthriveAuthObj = store.get('adthriveAuthObj');
  let token = adthriveAuthObj && adthriveAuthObj.token;

  return function(dispatch, getState){
    let url = `${api.GET_BASE_URL('ADTHRIVE_API_BASE_URL')}${api.ADTHRIVE_SITES_ENDPOINT()}?sort=name`
    return fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    }).then((response) => {
      return response.json();
    }).then((data) => {
      dispatch(setAdthriveSites(data.data));
      if(_.isFunction(callback)){
        callback();
      }
    }).catch((e) => {
      console.log('something went wrong getting adthrive sites');
    });
  }
}